import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequestService } from '@df/api/request/request.service';
import { SessionStorage } from '@df/browser/storage/decorator/session-storage';
import { App } from '@df/core/app';
import { Gtm } from '@df/module-gtm/gtm.namespace';
import { GTMServiceEventAfter, GTMServiceTrackBackendEvent, GtmService } from '@df/module-gtm/gtm.service';
import { TimeoutService } from '@df/ng/timeout.service';
import { Subscription } from 'rxjs/internal/Subscription';

export interface IStudentBeansData {
    transaction_id: string;
    amount: string;
    adv_sub: string;
    adv_sub2: string;
    adv_sub3: string;
    adv_sub4?: string;
    adv_sub5: string;
}

@Injectable({
    providedIn: 'root'
})
export class StudentBeans {
    @SessionStorage('studentBeansId')
    protected studentBeansId!: string;

    protected gtmSubscription?: Subscription;

    private timeoutService = inject(TimeoutService);

    constructor(
        protected app: App,
        protected activatedRoute: ActivatedRoute,
        protected gtmService: GtmService,
        protected requestService: RequestService
    ) {
        this.activatedRoute.queryParams.subscribe(queryParams => {
            const id = queryParams['aff_sub'];
            if (id) {
                this.studentBeansId = id;
            }
            this.setSubscription();
        });
    }

    private setSubscription = this.timeoutService.debounce(() => {
        if (!this.gtmSubscription && this.studentBeansId && this.app.multisite.current.country === 'US') {
            this.gtmSubscription = this.gtmService.events.subscribe((event: GTMServiceTrackBackendEvent) => {
                if (event.eventData.event === 'checkoutSuccess' && event instanceof GTMServiceEventAfter) {
                    const eventData = event.eventData as Gtm.IEventPurchase;
                    const purchase = eventData.ecommerce.purchase;
                    const customer = eventData['event-data'].customer;

                    if (purchase && customer && purchase.actionField) {
                        const data: IStudentBeansData = {
                            transaction_id: this.studentBeansId,
                            amount: purchase.actionField.revenue.toString(),
                            adv_sub: purchase.actionField.id,
                            adv_sub2: customer.returning ? 'existing' : 'new',
                            adv_sub3: purchase.products.map(product => product.id).join('|'),
                            adv_sub5: customer.id.toString()
                        };

                        if (purchase.actionField.coupon) {
                            data.adv_sub4 = purchase.actionField.coupon;
                        }

                        this.requestService.sendXHR('https://studentbeansnetwork.go2cloud.org/aff_lsr', undefined, {
                            method: 'POST',
                            params: data
                        });
                    }
                }
            });
        }
    }, 500);
}
